/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

// Configs
import { env } from "@/configs/env.config";
import { ApiError } from "@/helpers/api.helper";
import { ApiRequestMethod } from "@/types/api";
import globalErrorHandler from "@/helpers/global-error-handler.helper";

/* -------------------------------------------------------------------------- */
/*                                   Config                                   */
/* -------------------------------------------------------------------------- */
const physiomKineApi = axios.create({
  baseURL: env.physiomKine.api.baseUrl,
});

const onRequest = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  config.withCredentials = true;
  config.withXSRFToken = true;
  config.xsrfCookieName = "csrftoken";
  config.xsrfHeaderName = "X-CSRFTOKEN";
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse) => {
  return response.data;
};

const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  const { responseURL } = error.request;
  let { pathname } = new URL(responseURL);

  pathname = pathname.replace("/api/", "");

  const apiError = new ApiError({
    route: pathname,
    status: error.response?.status,
    method: error.config?.method?.toUpperCase() as ApiRequestMethod,
  });

  apiError.data = error.response?.data;

  globalErrorHandler(apiError);
  return Promise.reject(apiError);
};

physiomKineApi.interceptors.request.use(onRequest, onRequestError);
physiomKineApi.interceptors.response.use(onResponse, onResponseError);

export default physiomKineApi;
